import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of, map, catchError } from 'rxjs';
import { TenantResolved } from '../models/TenantDto';
import { TenantService } from './tenant.service';

@Injectable({providedIn: 'root'})
export class TenantResolverService {

  constructor(private tenantService: TenantService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): TenantResolved | Observable<TenantResolved> | Promise<TenantResolved> {
    
    const id = route.paramMap.get('id') as string;    

    if (id === '') {
      const message = `No User id was provided: ${id}`;
      console.log(message);
      //return of({ userDto: null, error: message });
      return of(new TenantResolved)
    }
    return this.tenantService.getTenant(id)
    .pipe(map(tenantDto => ({tenantDto: tenantDto})),
    catchError(error => {
      const message = `Retrieval error: ${error}`;
      return of(new TenantResolved)
    }));
  }
}
